import { FormControl, FormGroup } from '@angular/forms';
import { Nillable } from '@web/utils';
import { AdminShipmentSizeType } from '../enums/admin-shipment-size-type';
import { AdminOrderShipmentFormItem } from './admin-order-shipment-form-item';

export type AdminAdditionalShippingControls = {
  size: FormControl<Nillable<AdminShipmentSizeType>>;
  scheduledShippingDate: FormControl<Nillable<Date>>;
  comment: FormControl<Nillable<string>>;
  boxes: FormControl<AdminOrderShipmentFormItem[]>;
  products: FormControl<AdminOrderShipmentFormItem[]>;
  cosmetics: FormControl<AdminOrderShipmentFormItem[]>;
};

export class AdminAdditionalShippingData {
  public static CommentMaxLength = 500;

  public constructor(
    private readonly data: {
      size: AdminShipmentSizeType;
      scheduledShippingDate?: Nillable<Date>;
      comment: Nillable<string>;
      boxes: AdminOrderShipmentFormItem[];
      products: AdminOrderShipmentFormItem[];
      cosmetics: AdminOrderShipmentFormItem[];
    },
  ) {}

  public get size(): AdminShipmentSizeType {
    return this.data.size;
  }

  public get scheduledShippingDate(): Nillable<Date> {
    return this.data.scheduledShippingDate;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get boxes(): AdminOrderShipmentFormItem[] {
    return this.data.boxes;
  }

  public get products(): AdminOrderShipmentFormItem[] {
    return this.data.products;
  }

  public get cosmetics(): AdminOrderShipmentFormItem[] {
    return this.data.cosmetics;
  }
}

/* prettier-ignore */
export type AdminAdditionalShippingFormGroup = FormGroup<AdminAdditionalShippingControls>;
